// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CHIH","delete":"styles_delete__2QtAw","update":"styles_update__3-LV_","add":"styles_add__1nKtV"};